<template>
  <div class="details">
    <h4>{{ $lang.translate('track.header.details') }}</h4>
    
      <table>
        <tr>
          <th scope="row">{{ $lang.translate('track.label.shipmentNo') }}:</th>
          <td>{{ result.details.freightBillNo }}</td>
        </tr>
        <tr v-if="result.details.internalOrderId">
          <th scope="row">{{ $lang.translate('track.label.internalOrderId')}}:</th>
          <td>{{ result.details.internalOrderId }}</td>
        </tr>
        <tr>
          <th scope="row">{{ $lang.translate('track.label.senderReference') }}:</th>
          <td>{{ result.details.senderReference }}</td>
        </tr>
        <tr v-if="result.details.recipientReference">
          <th scope="row">{{ $lang.translate('track.label.recipientReference') }}:</th>
          <td>{{ result.details.recipientReference }}</td>
        <tr>
          <th scope="row">{{ $lang.translate('track.label.weight') }}:</th>
          <td>{{ weight }}</td>
        </tr>
        <tr v-if="result.details.totalVolume">
          <th scope="row">{{ $lang.translate('track.label.totalVolume')}}:</th>
          <td v-html="volume"></td>
        </tr>
        <tr v-if="result.details.totalColli">
          <th scope="row">{{ $lang.translate('track.label.totalColli')}}:</th>
          <td>{{ result.details.totalColli}}</td>
        </tr>
      </table>
      <div v-if="expanded">
        <p class="mt-2">
          <a href="#"  v-if="result.details.freightBillUrl" @click.prevent="downloadFreightBill" target="_blank">
            <strong><i class="icon-file-alt"></i> {{ $lang.translate('track.label.consignmentNote')}}</strong>
          </a>
          <AttachmentButton v-if="galleryAttachments.length" :attachments="galleryAttachments" />
        </p>
        <div class="has-space-between v-align">
          <PrintButton />
          <ShareButton />
        </div>
      </div>
  </div>
</template>

<script>
import { numberFormat, isTimelineAttachment } from '@/utils'
import PrintButton from './PrintButton'
import ShareButton from './ShareButton'
import AttachmentButton from './AttachmentButton'

export default {
  name: 'Details',
  props: {
    result: {
      type: Object,
      required: true
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    weight () {
      return this.result.details.totalWeight ? numberFormat(parseFloat(this.result.details.totalWeight)) + ' kg' : ''
    },
    volume () {
      return this.result.details.totalVolume ? `${this.result.details.totalVolume} m<sup>3</sup>` : ''
    },
    galleryAttachments () {
      const attachments = this.result.attachments || []
      const statuses = this.result.orderStatuses || []
      return attachments.filter(attachment => !isTimelineAttachment(attachment, statuses))
    }
  },
  methods: {
    downloadFreightBill () {
      window.open(this.result.details.freightBillUrl)
    }
  },
  components: {
    PrintButton,
    ShareButton,
    AttachmentButton
  }
}
</script>

<style scoped>
td, th {
  vertical-align: top;
}
table td {
  padding-left: 40px;
  word-break: break-all;
}
</style>